import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Year } from '../models/archive';
import { contentModel } from '../models/contentModel';
import {  menu } from '../models/menu';
import { page } from '../models/page';
import { rootModel } from '../models/rootModel';
import { slider } from '../models/slider';


@Injectable({
  providedIn: 'root'
})
export class DataService {

  apiadres: string;
  localAdres:string;
  constructor(
    private http: HttpClient) {
      this.apiadres =  'https://editorialgos.dpu.edu.tr/api/cms/';

    this.localAdres = "https://localhost/api/cms/";
  }
 

  getContent(rootmodel: rootModel): Observable<contentModel> {
    return this.http
      .post<contentModel>(this.apiadres + "category_content_get", rootmodel);
  }

  getPages(rootmodel: rootModel): Observable<page> {
    return this.http
      .post<page>(this.apiadres + "get_page_content", rootmodel);
  }

  getSliders(rootModel: rootModel): Observable<any> {
    return this.http
      .post<any>(this.apiadres + "sliders_get", rootModel);
  }

  getHomePage(rootModel: rootModel): Observable<any> {
    return this.http
      .post<any>(this.apiadres + "get_home_page", rootModel);
  }


  getSliderDetay(slider :slider): Observable<any> {
    return this.http
      .post<any>(this.apiadres + "slider_get", slider);
  }
  getMenus(menu: rootModel): Observable<menu[]> {
   
    //const deger =  JSON.parse(JSON.stringify(contentModel));
    const langPath = `assets/i18n/i18n.json`;
    return this.http
      .post<menu[]>(this.apiadres + "categories_get",menu);
  }

  getMakale(root: rootModel):Observable<any>
  {
    //root.jou_uid="abbc630e-d842-446c-b4b6-75ade1165f3a";
    const langPath = `assets/i18n/article.json`;
  // return this.http.get<{}>(langPath);
    return this.http.post<Year[]>(this.apiadres+"articles_data",root);
  }

}

